import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { mapDispatchToProps, mapStateToProps } from "../../../utils/config";
import Usuario from "../../../models/Usuario";
import DeleteDialog from "../DeleteDialog";
import Toast from "../Toast";
import { interpretarDeixar, usuarioComoComum, mesclarTipoNaSessao, TEXTOS_DEIXAR } from "../../../utils/deixarProfissional";
import { Caixa } from "./styled";

/**
 * "Deixar de ser Profissional": o próprio Profissional volta a Comum na hora, sem pedir
 * aprovação (o papel é concedido pelo administrador; largar é como cancelar a assinatura).
 * Perde só a CRIAÇÃO de subgrupo e de área nova; o que já criou continua dele.
 *
 * O servidor é a fonte da verdade (POST /usuarios/deixar-profissional). Aqui só aparece para
 * quem é Profissional (Administrador não usa), e o aviso de sucesso é amigável (informativo).
 */
function DeixarProfissionalBase({ usuario, setUsuario }) {
  const [confirmando, setConfirmando] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState("");
  const [aviso, setAviso] = useState("");

  // O aviso some sozinho; vive aqui (e não no cartão) porque o cartão desaparece quando o
  // usuário vira Comum.
  useEffect(() => {
    if (!aviso) return undefined;
    const t = setTimeout(() => setAviso(""), 7000);
    return () => clearTimeout(t);
  }, [aviso]);

  function virarComum(resposta) {
    setUsuario(usuarioComoComum(usuario, resposta?.usuario));
    // A sessao guarda o token (a store nao): mescla so o tipo, sem regravar com o usuario da store.
    try {
      sessionStorage.setItem("usuario", JSON.stringify(mesclarTipoNaSessao(sessionStorage.getItem("usuario"))));
    } catch (e) { /* sessao indisponivel: a store ja esta atualizada */ }
  }

  async function confirmar() {
    if (enviando) return;
    setEnviando(true);
    setErro("");
    const r = interpretarDeixar(await Usuario.deixarProfissional());
    setEnviando(false);
    if (r.tipo === "ok") {
      virarComum(r);
      setConfirmando(false);
      setAviso(r.mensagem);
    } else if (r.tipo === "jaComum") {
      virarComum(r); // tela desatualizada: o servidor já tinha voltado a Comum
      setConfirmando(false);
      setAviso(r.mensagem);
    } else if (r.tipo === "aviso") {
      setConfirmando(false);
      setAviso(r.mensagem);
    } else {
      setErro(r.mensagem);
    }
  }

  return (
    <>
      <Toast variante="info" error={aviso} />
      {usuario?.tipo === "Profissional" &&
        <Caixa aria-labelledby="perfil-profissional-titulo">
          <h3 id="perfil-profissional-titulo">Perfil Profissional</h3>
          <p>Você pode criar subgrupos e registrar áreas. Se não precisar mais, é possível voltar ao perfil Comum a qualquer momento.</p>
          <button type="button" className="sair-do-perfil" onClick={() => { setErro(""); setConfirmando(true); }}>
            {TEXTOS_DEIXAR.botao}
          </button>
        </Caixa>
      }
      {confirmando &&
        <DeleteDialog
          titulo={TEXTOS_DEIXAR.titulo}
          subtitulo={<>{TEXTOS_DEIXAR.perde}<br />{TEXTOS_DEIXAR.mantem}<br />{TEXTOS_DEIXAR.volta}</>}
          textButton={enviando ? "Aguarde..." : TEXTOS_DEIXAR.confirmar}
          error={erro}
          onDelete={confirmar}
          onClose={() => { if (!enviando) { setConfirmando(false); setErro(""); } }}
        />
      }
    </>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DeixarProfissionalBase);
